/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Interpret a civil minute in its selected IANA zone, independently of browser TZ.
 * DST gaps and duplicate minutes fail closed; no date library, timer, or network is needed. */
function formatter(timeZone: string) {
  return new Intl.DateTimeFormat('en-CA-u-ca-gregory-nu-latn', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
}
function civilParts(date: Date, format: Intl.DateTimeFormat) {
  const parts = Object.fromEntries(format.formatToParts(date).map(part => [part.type, part.value]));
  return [Number(parts.year), Number(parts.month), Number(parts.day), Number(parts.hour), Number(parts.minute)] as const;
}
function wallString(parts: readonly number[]) {
  return String(parts[0]).padStart(4, '0') + '-' + String(parts[1]).padStart(2, '0') + '-' + String(parts[2]).padStart(2, '0')
    + 'T' + String(parts[3]).padStart(2, '0') + ':' + String(parts[4]).padStart(2, '0');
}
export function formatScheduleWallTime(date: Date, timeZone: string): string {
  return wallString(civilParts(date, formatter(timeZone)));
}
export type ScheduleWallTimeResult = { status: 'UNIQUE'; instant: string } | { status: 'INVALID' | 'NONEXISTENT' | 'AMBIGUOUS' };
export function resolveScheduleWallTime(value: string, timeZone: string): ScheduleWallTimeResult {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) return { status: 'INVALID' };
  const [year, month, day, hour, minute] = match.slice(1).map(Number);
  if (year! < 1000 || month! < 1 || month! > 12 || day! < 1 || hour! > 23 || minute! > 59) return { status: 'INVALID' };
  const naive = Date.UTC(year!, month! - 1, day!, hour!, minute!);
  if (new Date(naive).toISOString().slice(0, 16) !== value) return { status: 'INVALID' };
  try {
    const format = formatter(timeZone), offsets = new Set<number>(), matches = new Set<string>();
    // Sample both sides of transitions, including 30-minute DST and the international date line.
    for (let hours = -36; hours <= 36; hours += 6) {
      const timestamp = naive + hours * 3600000;
      const [y, m, d, h, min] = civilParts(new Date(timestamp), format);
      offsets.add(Date.UTC(y, m - 1, d, h, min) - timestamp);
    }
    for (const offset of offsets) {
      const date = new Date(naive - offset);
      if (wallString(civilParts(date, format)) === value) matches.add(date.toISOString());
    }
    return matches.size === 1 ? { status: 'UNIQUE', instant: [...matches][0]! }
      : { status: matches.size ? 'AMBIGUOUS' : 'NONEXISTENT' };
  } catch { return { status: 'INVALID' }; }
}
